import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { showToast, signOut, userHasRole } from "services/helper";
import "./Header.scss";
import { BiUserCircle } from "react-icons/bi";
import { headerScreens } from "assets/constants/screens";
import { useSelector } from "react-redux";

export function Header() {
  const userIsLogged = useSelector((state) => state?.user?.token)?.length > 0;
  const user = useSelector(state => state?.user.data);
  const navigate = useNavigate();

  function onSignOut() {
    signOut().then(() => {
      showToast("Até logo!", "success");
      navigate("/login");
    });
  }

  return (
    <header className="header">
      <Link to={"/"}>
        <img
          src={require("assets/images/logo.png")}
          alt="SEO Analyzer's logo"
          title="Logo"
        />
      </Link>
      <input className="side-menu" type="checkbox" id="side-menu" />
      <label className="hamb" htmlFor="side-menu">
        <span className="hamb-line"></span>
      </label>
      <nav className="nav">
        <ul className="menu">
          {headerScreens.map((screen) => {
            const { path, label } = { ...screen };
            if (!userHasRole(screen.roles)) return null;
            return (
              <li key={path}>
                <Link to={path}>{label}</Link>
              </li>
            );
          })}
          {userIsLogged && (
            <li className="user-icon-container">
              <BiUserCircle size={30} />
              <ul className="user-sublist">
                <div className="username">
                  <BiUserCircle size={30} />
                  <span>
                    {user && user.name}
                  </span>
                </div>
                <li>
                  <Link to="/change-password">Alterar Senha</Link>
                </li>
                <li>
                  <button onClick={onSignOut}>Sair</button>
                </li>
              </ul>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
}
